export default {
      id: "comparison-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#comparison",
      toString: function () {
        return this.url;
      }
    }